import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/start/$stepId")({
  beforeLoad: () => {
    throw redirect({ to: "/explore" });
  },
});
